import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import potGlace90 from "@/assets/products/pot-glace-90ml.jpg";
import potGlace110 from "@/assets/products/pot-glace-110ml.jpg";
import potGlace180 from "@/assets/products/pot-glace-180ml.png";
import potGlace230 from "@/assets/products/pot-glace-230ml.jpg";

const config: ProductPageConfig = {
  name: "Pots à glace en carton kraft",
  breadcrumbName: "Pots à glace",
  subtitle: "Parfaits pour glaces artisanales, yaourts glacés et desserts",
  features: ["Contact alimentaire", "Recyclable", "Résistant au froid", "Disponible en stock"],
  variants: [
    { ref: "GTKHELADO3OZ", capacity: "90 ml (3 oz)", diameter: "Ø 70 mm", height: "45 mm", material: "Carton kraft", packaging: "Carton de 1 000 (20 x 50)", palette: "48 cartons", image: potGlace90 },
    { ref: "GTKHELADO4OZ", capacity: "110 ml (4 oz)", diameter: "Ø 75 mm", height: "50 mm", material: "Carton kraft", packaging: "Carton de 1 000 (20 x 50)", palette: "48 cartons", image: potGlace110 },
    { ref: "GTKHELADO6OZ", capacity: "180 ml (6 oz)", diameter: "Ø 85 mm", height: "55 mm", material: "Carton kraft", packaging: "Carton de 1 000 (20 x 50)", palette: "24 cartons", image: potGlace180 },
    { ref: "GTKHELADO8OZ", capacity: "230 ml (8 oz)", diameter: "Ø 95 mm", height: "60 mm", material: "Carton kraft", packaging: "Carton de 1 000 (20 x 50)", palette: "16 cartons", image: potGlace230 },
  ],
};

const PotsGlace = () => <ProductPageLayout config={config} />;
export default PotsGlace;
